import React from 'react'

import { reverse } from 'named-urls'
import { Link } from 'react-router-dom'

import { Tooltip, IconButton, Typography, makeStyles } from '@material-ui/core'

import { Edit } from '@material-ui/icons'

import { routes } from 'routes'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { Permitted } from 'components/Permissions'
import { LogIconButton } from 'components/Logs'

import { DotStatus } from 'components'

import styles from './styles'

const useStyles = makeStyles(styles)

const TableRowUser = ({ user }) => {
  const classes = useStyles()

  return (
    <TableRow hover key={user.id}>
      <TableCell className={classes.tableCellName}>
        <Typography noWrap>{user.name}</Typography>
      </TableCell>
      <TableCell className={classes.tableCellEmail}>
        <Typography noWrap>{user.email}</Typography>
      </TableCell>
      <TableCell>{user.profile.name}</TableCell>
      <TableCell align="center">
        <DotStatus
          statusName={user.active ? 'Ativo' : 'Inativo'}
          statusTag={user.active ? 'active' : 'inactive'}
        />
      </TableCell>
      <Permitted admin>
        <TableCell align="right">
          <LogIconButton
            to={reverse(routes.settings.users.logs, { userId: user.id })}
          />

          <Tooltip title="Editar">
            <IconButton
              component={Link}
              to={reverse(routes.settings.users.edit, { userId: user.id })}
            >
              <Edit />
            </IconButton>
          </Tooltip>
        </TableCell>
      </Permitted>
    </TableRow>
  )
}

const UsersTable = ({ users, isLoading, onEvent = () => {} }) => {
  return (
    <Table isLoading={isLoading} noWrap>
      <TableHead>
        <TableRow>
          <TableCell>Nome</TableCell>
          <TableCell>Email</TableCell>
          <TableCell>Perfil</TableCell>
          <TableCell align="center">Status</TableCell>
          <Permitted admin>
            <TableCell></TableCell>
          </Permitted>
        </TableRow>
      </TableHead>
      <TableBody>
        {users &&
          users.map((user, index) => <TableRowUser user={user} key={index} />)}
      </TableBody>
    </Table>
  )
}

export default UsersTable
